<h2 mat-dialog-title class="m-0">User Preferences</h2>
<form [formGroup]="userPreferencesForm" (ngSubmit)="onSubmit()">
	<div mat-dialog-content>
		<mat-tab-group>
			<mat-tab label="Pin Size">
				<div class="center-slider">
                    <mat-slider
                        class="slider-formatting"
                        [max]="100"
                        [min]="10"
                        [step]="10"
                        [discrete]="true"
                        [showTickMarks]="true"
                        [displayWith]="formatLabel"
                        color="primary"
                        aria-labelledby="Pin_Slider">
                        <input
                            matSliderThumb
                            [value]="50"
                            (valueChange)="calculatePinSize($event)">
                    </mat-slider>
                </div>

                <div id="mapPref" style="min-height: 500px;"></div>
			</mat-tab>
		</mat-tab-group>
	</div>

	<div mat-dialog-actions>
        <div class="col-12">
            <button mat-stroked-button mat-dialog-close>Cancel</button>
            <button type="submit" class="float-end" mat-raised-button
                color="primary" cdkFocusInitial>Save Preferences</button>
        </div>
    </div>
</form>